import { render, staticRenderFns } from "./EventMetrics.vue?vue&type=template&id=1ed9160a&scoped=true"
import script from "./EventMetrics.vue?vue&type=script&lang=ts"
export * from "./EventMetrics.vue?vue&type=script&lang=ts"
import style0 from "./EventMetrics.vue?vue&type=style&index=0&id=1ed9160a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed9160a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VList,VListItem,VListItemContent,VSubheader})
